
import { Component, Vue, Watch } from 'vue-property-decorator'
import { MediaService } from '@/services/index'
import TableHeader from '@/components/table_header/index.vue'
import OrgTable from './components/orgTable.vue'

@Component({
    name: 'MediaOrgList',
    components: {
        OrgTable,
        TableHeader
    }
})
export default class extends Vue {
    private orgList = []
    private pageIndex: number = 1
    private pageSize: number = 50
    private pageTotal: number = 0
    private loading: boolean = false
    private tableHeaderDecs: string = ''
    private searchQuery: string = ''
    
    private mounted() {
        this.fetchOrgList()
    }

    private async fetchOrgList() {
        this.loading = true
        this.requestData()
        this.loading = false
    }

    private async requestData() {
        const params = { 
            page_index: this.pageIndex, 
            page_size: this.pageSize,
            query: this.searchQuery
        }
        const result = await MediaService.getOrgList(params)
        if (result.status === 200) {
            this.pageTotal = result.data.page_total
            this.orgList = result.data.org_list
            this.tableHeaderDecs = '一共有 ' + this.pageTotal + ' 家'
        }
    }

    private onCurrentChange(page: any) {
        const $backtop = this.$refs.backtop as any
        this.pageIndex = page
        this.fetchOrgList()
        $backtop.scrollToTop()
    }

    private onCreate() {
        this.$router.push({ name: 'MediaOrgCreate' })
    }

    private onSearch() {
        this.pageIndex = 1
        this.requestData()
    }

    // 监听搜索回车键
    private onKeyup(event: any) {
        if (event.keyCode === 38 || event.keyCode === 40) return
        if (event.keyCode === 13) {
            this.onSearch()
        }
    }

    @Watch('$route')
    routechange(to: any, from: any) {
        if (from.name === 'MediaOrgCreate' || from.name === 'MediaOrgEdit') {
            this.requestData()
        }
    }
}
